;(function() {
  'use strict'

  Controller.$inject = ["glDialog", "QuotaPlan", "QuotaDefinition", "quotaTextService", "quotaSaveService"];
  angular.module('app.core').component('quotaManager', {
    controller: Controller,
    templateUrl: 'quota-manager.html',
    bindings: {
      survey: '<',
      channels: '<',
      initialDirty: '<',
      setupUnsaved: '<',
      onDirtyChange: '&',
      onGoToChannels: '&',
    },
  })

  /* @ngInject */
  function Controller(
    glDialog,
    QuotaPlan,
    QuotaDefinition,
    quotaTextService,
    quotaSaveService
  ) {
    var ctrl = this

    var pluralise = quotaTextService.pluralise
    var channelSignature = null
    var collapsedByQuotaId = {}

    ctrl.Modes = QuotaDefinition.Modes

    ctrl.sectionCollapse = {
      INTERLOCKED: { seq: 0, collapsed: false, allCollapsed: false },
      INDEPENDENT: { seq: 0, collapsed: false, allCollapsed: false },
    }
    ctrl.interlockedCollapse =
      ctrl.sectionCollapse[QuotaDefinition.Modes.INTERLOCKED]
    ctrl.separateCollapse =
      ctrl.sectionCollapse[QuotaDefinition.Modes.INDEPENDENT]

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.$doCheck = doCheck

    ctrl.selectPlan = selectPlan
    ctrl.addPlan = addPlan
    ctrl.renamePlan = renamePlan
    ctrl.deletePlan = deletePlan
    ctrl.addQuota = addQuota
    ctrl.deleteQuota = deleteQuota
    ctrl.toggleSectionCollapsed = toggleSectionCollapsed
    ctrl.onCardCollapsedChange = onCardCollapsedChange
    ctrl.onQuotaCardChange = onQuotaCardChange
    ctrl.setDirty = setDirty
    ctrl.save = save

    function onInit() {
      ctrl.dirty = ctrl.initialDirty === true
      ctrl.saving = false

      refreshPlans()
    }

    function onChanges(changes) {
      if (changes.survey && !changes.survey.isFirstChange()) {
        ctrl.dirty = false
        refreshPlans()
      }
    }

    function doCheck() {
      var channels = ctrl.channels || []
      var signature =
        channels.length +
        ':' +
        _.filter(channels, { tagQuotasEnabled: true }).length

      if (signature === channelSignature) return

      channelSignature = signature
      refreshFromChannels()
    }

    function getPlans() {
      return _.isArray(ctrl.survey.quotaPlans) ? ctrl.survey.quotaPlans : []
    }

    function refreshPlans() {
      ctrl.questions = ctrl.survey.getQuestions()
      ctrl.tagCounts = ctrl.survey.tagCounts || {}
      ctrl.surveyTags = ctrl.survey.getTags()
      ctrl.responseCount = ctrl.survey.responseCount || 0
      ctrl.plans = getPlans()

      var selected = _.find(ctrl.plans, { id: ctrl.selectedPlanId })
      ctrl.selectedPlanId = selected
        ? selected.id
        : ctrl.plans.length
        ? ctrl.plans[0].id
        : null

      refreshTabs()
      refreshSelectedPlan()
    }

    function refreshTabs() {
      ctrl.planTabs = ctrl.plans.map(function(plan) {
        return { label: plan.name, value: plan.id }
      })
    }

    function refreshSelectedPlan() {
      ctrl.plan = _.find(ctrl.plans, { id: ctrl.selectedPlanId }) || null

      if (!ctrl.plan) {
        ctrl.interlockedQuotas = []
        ctrl.separateQuotas = []

        refreshCountingNotice()
        return
      }

      ctrl.interlockedQuotas = ctrl.plan.getQuotas(
        QuotaDefinition.Modes.INTERLOCKED
      )
      ctrl.separateQuotas = ctrl.plan.getQuotas(
        QuotaDefinition.Modes.INDEPENDENT
      )

      refreshSectionCollapseState()
      refreshCountingNotice()
    }

    function toggleSectionCollapsed(mode) {
      var section = ctrl.sectionCollapse[mode]

      if (!section) return

      section.collapsed = !section.allCollapsed
      section.seq++
    }

    function onCardCollapsedChange(quotaId, collapsed) {
      if (!quotaId) return

      if (collapsed) {
        collapsedByQuotaId[quotaId] = true
      } else {
        delete collapsedByQuotaId[quotaId]
      }

      refreshSectionCollapseState()
    }

    function refreshSectionCollapseState() {
      ctrl.sectionCollapse.INTERLOCKED.allCollapsed = isSectionAllCollapsed(
        ctrl.interlockedQuotas
      )
      ctrl.sectionCollapse.INDEPENDENT.allCollapsed = isSectionAllCollapsed(
        ctrl.separateQuotas
      )
    }

    function isSectionAllCollapsed(quotas) {
      if (_.isEmpty(quotas)) return false

      return _.every(quotas, function(quota) {
        return collapsedByQuotaId[quota.id] === true
      })
    }

    function refreshFromChannels() {
      var channels = ctrl.channels || []
      ctrl.legacyChannels = _.filter(channels, { tagQuotasEnabled: true })
      ctrl.isBlocked = ctrl.legacyChannels.length > 0
    }

    function selectPlan(planId) {
      ctrl.selectedPlanId = planId
      refreshSelectedPlan()
    }

    function addPlan() {
      showPlanDialog({
        title: 'Create plan',
        confirmLabel: 'Create',
        name: '',
        showIntro: true,
      })
        .then(function(name) {
          if (!_.isArray(ctrl.survey.quotaPlans)) {
            ctrl.survey.quotaPlans = []
          }
          var plan = new QuotaPlan()
          plan.name = name
          ctrl.survey.quotaPlans.push(plan)

          setDirty()
          ctrl.selectedPlanId = plan.id
          refreshPlans()
        })
        .catch(_.noop)
    }

    function renamePlan() {
      if (!ctrl.plan) return

      var plan = ctrl.plan

      showPlanDialog({
        title: 'Rename plan',
        confirmLabel: 'Rename',
        name: plan.name,
      })
        .then(function(name) {
          plan.name = name
          setDirty()
          refreshTabs()
        })
        .catch(_.noop)
    }

    function deletePlan() {
      if (!ctrl.plan) return

      var plan = ctrl.plan
      var quotaCount = plan.getQuotas().length
      var targetCount = countTargets(plan)

      var message =
        'This removes ' +
        pluralise(quotaCount, 'quota', 'quotas') +
        ' and ' +
        pluralise(targetCount, 'target', 'targets') +
        '. ' +
        buildDeletePlanCountsSentence(plan) +
        ' Its channels will have no quotas.'

      glDialog
        .confirm('Delete "' + plan.name + '"?', message)
        .then(function() {
          _.remove(ctrl.survey.quotaPlans, { id: plan.id })

          setDirty()
          refreshPlans()
        })
        .catch(_.noop)
    }

    function countTargets(plan) {
      return _.sumBy(plan.getQuotas(), function(quota) {
        return countQuotaTargets(plan, quota)
      })
    }

    function countQuotaTargets(plan, quota) {
      return _.keys(plan.targetSets[0].targets[quota.id] || {}).length
    }

    function showPlanDialog(options) {
      // prettier-ignore
      var template = [
        '<gl-dialog class="quota-plan-dialog__dialog">',
          '<quota-plan-dialog ',
            'dialog-title="dialogTitle" ',
            'confirm-label="confirmLabel" ',
            'name="name" ',
            'show-intro="showIntro" ',
            'on-confirm="dialog.close($name)" ',
            'on-cancel="dialog.cancel()" ',
          '/>',
        '</gl-dialog>',
      ]

      return glDialog.show({
        template: template.join(' '),
        clickOutsideToClose: false,
        escapeToClose: true,
        locals: {
          dialogTitle: options.title,
          confirmLabel: options.confirmLabel,
          name: options.name,
          showIntro: !!options.showIntro,
        },
      })
    }

    function addQuota(mode) {
      if (!ctrl.plan) return

      ctrl.plan.addQuota(mode)
      setDirty()
      refreshSelectedPlan()
    }

    function deleteQuota(quota) {
      if (!ctrl.plan || !quota) return

      var plan = ctrl.plan

      glDialog
        .confirm(
          'Delete "' + quota.name + '"?',
          buildDeleteQuotaMessage(plan, quota),
          {
            locals: {
              closeText: 'Delete quota',
              cancelText: 'Cancel',
            },
          }
        )
        .then(function() {
          plan.removeQuota(quota)
          setDirty()
          refreshSelectedPlan()
        })
        .catch(_.noop)
    }

    function buildDeleteQuotaMessage(plan, quota) {
      var targetCount = countQuotaTargets(plan, quota)

      var targetSentence = targetCount
        ? 'This removes ' + pluralise(targetCount, 'target', 'targets') + '.'
        : 'This quota has no targets.'

      return targetSentence + ' ' + buildDeleteQuotaCountsSentence(quota)
    }

    function quotaHasGeneratedCounters(quota) {
      var variables = quota.variables || []
      if (!variables.length) return false

      return (
        quota.isInterlocked() ||
        _.some(variables, function(variable) {
          return variable.isQuestion()
        })
      )
    }

    function quotaHasRawTagCounters(quota) {
      var variables = quota.variables || []
      if (!variables.length) return false

      return (
        quota.isIndependent() &&
        _.some(variables, function(variable) {
          return variable.isTag()
        })
      )
    }

    function buildDeletePlanCountsSentence(plan) {
      var quotas = plan.getQuotas()

      var hasGenerated = _.some(quotas, quotaHasGeneratedCounters)
      var hasRawTag = _.some(quotas, quotaHasRawTagCounters)

      if (!hasGenerated && !hasRawTag) {
        return 'Nothing has been counted against it.'
      }

      if (hasGenerated && hasRawTag) {
        return (
          'Rows built from tags keep their history — they count the tags ' +
          'themselves. Rows built from questions do not: a new plan gets new ' +
          'counters and starts from zero.'
        )
      }

      if (hasRawTag) {
        return (
          'Nothing that has been counted is lost — these rows count the tags ' +
          'themselves, so a new plan built from the same tags shows the same ' +
          'history again.'
        )
      }

      return (
        'The responses already counted here are not deleted, but a new plan ' +
        'cannot reach them — it gets new counters and starts from zero.'
      )
    }

    function buildDeleteQuotaCountsSentence(quota) {
      var variables = quota.variables || []

      if (!variables.length) {
        return 'It has no variables, so nothing has been counted against it.'
      }

      var hasGenerated = quotaHasGeneratedCounters(quota)
      var hasRawTag = quotaHasRawTagCounters(quota)

      if (hasGenerated && hasRawTag) {
        return (
          'Rows built from tags keep their history — they count the tags ' +
          'themselves. Rows built from questions do not: a new quota gets new ' +
          'counters and starts from zero.'
        )
      }

      if (hasRawTag) {
        return (
          'Nothing that has been counted is lost — these rows count the tags ' +
          'themselves, so a new quota built from the same tags shows the same ' +
          'history again.'
        )
      }

      return (
        'The responses already counted here are not deleted, but a new quota ' +
        'cannot reach them — it gets new counters and starts from zero.'
      )
    }

    function refreshCountingNotice() {
      ctrl.showCountingNotice =
        ctrl.responseCount > 0 && planHasMixedCountingQuota()
    }

    function planHasMixedCountingQuota() {
      if (!ctrl.plan) return false
      return _.some(ctrl.plan.getQuotas(), quotaHasMixedCounting)
    }

    function quotaHasMixedCounting(quota) {
      if (!quota || !quota.isIndependent()) return false

      var variables = quota.variables || []

      var hasTag = _.some(variables, function(variable) {
        return variable.isTag()
      })

      var hasQuestion = _.some(variables, function(variable) {
        return variable.isQuestion()
      })

      return hasTag && hasQuestion
    }

    function onQuotaCardChange() {
      refreshCountingNotice()
      setDirty()
    }

    function setDirty() {
      ctrl.dirty = true
      ctrl.onDirtyChange({ $dirty: true })
    }

    function save() {
      // the button is disabled while saving, but the handler is still reachable and a second call would send a second save
      if (ctrl.saving) return

      ctrl.saving = true

      quotaSaveService
        .save(ctrl.survey)
        .then(function() {
          ctrl.dirty = false
          ctrl.onDirtyChange({ $dirty: false })
        })
        .catch(_.noop)
        .finally(function() {
          ctrl.saving = false
        })
    }
  }
})()
